// app/javascript/controllers/user_schedule_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.updateInputStates()
  }

  toggleDay(event) {
    const day = event.target.dataset.dayToggle
    this.updateDayInputs(day, event.target.checked)
  }

  updateDayInputs(day, enabled) {
    const inputs = document.querySelector(`[data-day-inputs="${day}"]`)
    if (inputs) {
      const timeInputs = inputs.querySelectorAll('input[type="time"]')
      timeInputs.forEach(input => {
        input.disabled = !enabled
        if (!enabled) {
          input.classList.add('bg-gray-100', 'text-gray-500')
        } else {
          input.classList.remove('bg-gray-100', 'text-gray-500')
        }
      })
    }
  }

  updateInputStates() {
    // Mise à jour initiale de l'état des inputs au chargement
    const checkboxes = document.querySelectorAll('[data-day-toggle]')
    checkboxes.forEach(checkbox => {
      const day = checkbox.dataset.dayToggle
      this.updateDayInputs(day, checkbox.checked)
    })
  }
}
